export default __webpack_public_path__ + "static/media/manualHighlight.fa00bcb0.gif";